import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import Utils from '../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor() {}

  private downloadMessage = new BehaviorSubject<[number, string]>(null);
  currentDownloadMessage = this.downloadMessage.asObservable();

  emitMessageHasBeenRead(index: number, message: string) {
    this.downloadMessage.next([index, message]);
  }

  efetuarDownloadMsgInstitucional(numeroMensagem, dtPublicacao, tituloMensagem, mensagem, nomeArquivoComExtensao) {
    const pulaLinha = '\r\n';
    const montaMensagem = 'NSU: '.concat(numeroMensagem).concat(pulaLinha).concat('Enviado em: ').concat(dtPublicacao)
   .concat(pulaLinha).concat('Título: ').concat(tituloMensagem).concat(pulaLinha).concat(pulaLinha).concat(mensagem);
    const url = URL.createObjectURL( new Blob([montaMensagem]));
    this.finalizarDownload(url, nomeArquivoComExtensao);
  }

  efetuarDownloadXml(xml, nomeArquivoComExtensao) {
    const url = URL.createObjectURL( new Blob([xml], {type: 'application/xml'}));
    this.finalizarDownload(url, nomeArquivoComExtensao);
  }
  efetuaDownload(arquivo, nomeArquivoComExtensao, contentType) {
    const url = URL.createObjectURL( new Blob([arquivo], {type: contentType}));
    this.finalizarDownload(url, nomeArquivoComExtensao);
  }
   efetuarDownload(arquivo, contentType, nomeArquivoComExtensao, sliceSize?) {
    const blob = Utils.b64toBlob(arquivo, contentType, sliceSize);
    const url = URL.createObjectURL(blob);
    this.finalizarDownload(url, nomeArquivoComExtensao);
  }

  private finalizarDownload(url, nomeArquivoComExtensao){
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = nomeArquivoComExtensao;
    a.click();
    setTimeout(function() {
      window.URL.revokeObjectURL(url);
    }, 100);
    this.emitMessageHasBeenRead(1, 'A Message has been read');
  }

}
